import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { selectedProfileAction } from './slice';
import { useEnrollmentProfileQuery } from 'enrollment/queries';
import {
  chooseAvatarAction,
  selectAvatarHairColorAction,
  selectAvatarShirtColorAction,
  selectAvatarSkinToneAction,
  storeCroppedImage,
} from '../Avatar/AvatarActions';
import {
  avatarList,
  defaultAvatarHairColor,
  defaultAvatarShirtColor,
  defaultAvatarSkinTone,
  hairColorPalette,
  shirtColorPalette,
  skinColorPalette,
} from 'enrollment/app/constants';
import { PsButtonTuner } from 'stencilSetup';

interface ProfileApiProps {
  navigateTo?: string;
}

export const SkipProfileSelection = ({ navigateTo }: ProfileApiProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('pages.enrollmentDashboard');

  const { subscriber } = useEnrollmentProfileQuery({ lumosEnabled: true });
  const redirectLink = '/enrollment/profile/edit';
  const profileAvatar = subscriber?.data?.subscriber_profile?.avatar;
  const profilePicture = subscriber?.data?.subscriber_profile?.profile_picture;
  const profileRedirectLink = useSelector(
    (state: any) => state?.authentication?.redirectLink
  );
  const skipProfileSelection = () => {
    if (
      Boolean(profileAvatar) &&
      profileRedirectLink !== '/enrollment/family'
    ) {
      const avatarName = profileAvatar.split('_')[0];
      const avatarPicture = avatarList.filter(
        (item) => profileAvatar && avatarName === item.name
      );
      const avatarSkincolor = skinColorPalette.filter(
        (item) => profileAvatar && profileAvatar.split('_')[1] === item.name
      );
      const avatarHairColor = hairColorPalette.filter(
        (item) => profileAvatar && profileAvatar.split('_')[2] === item.name
      );
      const avatarShirtColor = shirtColorPalette.filter(
        (item) => profileAvatar && profileAvatar.split('_')[3] === item.name
      );

      dispatch(chooseAvatarAction(avatarPicture[0], redirectLink));
      dispatch(
        selectAvatarSkinToneAction(
          avatarSkincolor?.length === 0
            ? {
                id: 'defaultAvatarSkinTone',
                colorCode: defaultAvatarSkinTone,
                name: 'defaultSkinColor',
              }
            : avatarSkincolor[0]
        )
      );
      dispatch(
        selectAvatarHairColorAction(
          avatarHairColor?.length === 0
            ? {
                id: 'defaultAvatarHairColor',
                colorCode: defaultAvatarHairColor,
                name: 'defaultSkinColor',
              }
            : avatarHairColor[0]
        )
      );
      dispatch(
        selectAvatarShirtColorAction(
          avatarShirtColor?.length === 0
            ? {
                id: 'defaultAvatarShirtColor',
                colorCode: defaultAvatarShirtColor,
                name: 'defaultShirtColor',
              }
            : avatarShirtColor[0]
        )
      );
      dispatch(selectedProfileAction(avatarName));
    } else if (
      Boolean(profilePicture) &&
      profileRedirectLink !== '/enrollment/family'
    ) {
      dispatch(storeCroppedImage(profilePicture));
    }

    navigate(`/enrollment/${navigateTo}`);
  };

  return (
    <div className="mt-4">
      <PsButtonTuner
        buttonId="skip-button"
        label={t('skipForNow')}
        level="tertiary"
        onClick={skipProfileSelection}
      />
    </div>
  );
};
